var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nocase_out"},[_c('div',{staticClass:"nocase"},[_c('p',[_vm._v("暂无样板工地播放")]),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.goYBGD}},[_vm._v(" 去设置样板工地 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }